<!--
 * @Author: klein
 * @Date: 2021-12-20 16:23:54
 * @Description:
 * @LastEditors: Klein
 * @LastEditTime: 2022-01-11 18:03:42
 * @FilePath: \planApp\src\components\Channel\ManageDialog.vue
-->
<template>
  <div>
    <el-dialog
      title="Why do you deactivate your subscription?"
      :visible.sync="dialogsync"
      custom-class="deactivate"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="cancel"
      top="calc(15vh + 150px)"
      :modal="true"
      append-to-body
      width="400px">

      <!-- manage subscription -->
      <div class="manage">
        <el-radio
          v-model="radio"
          label="1">I want to save money</el-radio>
        <el-radio
          v-model="radio"
          label="2">I can't find the feature I want</el-radio>
        <el-radio
          v-model="radio"
          label="3">Others</el-radio>
        <el-input
          v-if="radio == '3'"
          type="textarea"
          :rows="2"
          placeholder=""
          v-model="textarea">
        </el-input>
        <div class="note">Please note that after unsubscribing you will not be able to take live streams.</div>
      </div>
      <span
        slot="footer"
        class="dialog-footer">
        <el-button @click="cancel">Cancel</el-button>
        <el-button
          type="primary"
          @click="confirm">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogsync: true,
      radio: '1',
      textarea: ''
    }
  },
  methods: {
    confirm () {
      let desc = 'I want to save money'
      if (this.radio == '2') {
        desc = "I can't find the feature I want"
      } else if (this.radio == '3') {
        desc = this.textarea
      }
      this.$emit('confirm', desc)
    },
    cancel () {
      this.$emit('cancel', '')
    }
  }

}
</script>

<style lang="less">

.deactivate {
  .el-dialog__header .el-dialog__title {
    color: var(--content-table-color) !important;
  }
  .el-button, .el-button:focus, .el-button:hover {
    padding: 10px;
    color: var(--table-button-text-color);
    border-color: var(--table-button-border-color);
    background-color: var(--table-button-bg);
  }
  .el-button--primary {
    &:focus, &:hover {
      background: #33AB4F;
    }
    background: #33AB4F;
  }
  .el-radio {
    margin-top: 13px;
    display: block;
    .el-radio__input.is-checked + .el-radio__label {
      color:#DBDBDB;
    }
    .el-radio__input.is-checked .el-radio__inner {
      background: #56af31;
    }
    .el-radio__inner::after {
      background: #333;
      width: 6px;
      height: 6px;
    }
    .el-radio__label {
      font-weight: 500;
      color:#DBDBDB;
    }
    .el-radio__inner {
      background: #333;
      width: 16px;
      height: 16px;
      border: 0 none;
    }
  }
  .el-radio + .el-radio {
    margin-left: 0px;
  }
  .note {
    margin-top: 20px;
  }
  .el-textarea {
    margin-top: 10px;
    .el-textarea__inner {
      background-color: var(--dialog-input-bg);
      border-color: var(--dialog-input-border-color);
      color: var(--dialog-input-color);
    }
  }
}
</style>
